import {computed, h, ref} from 'vue'
import {usePanelManager} from '@tritt/multipanel'
import SimpleCrumb from '@/breadcrumbs/SimpleCrumb.vue'
import {PanelContent} from '@tritt/multipanel'

const breadcrumbContent = ref<Function[]>([])

const breadCrumbs = computed(() => breadcrumbContent.value)

export const useBreadCrumbs = () => {

    const buildSimpleCrumb = (route: PanelContent, name: string, icon: string, reportsPrefix: boolean = false) => {
        const crumb = h(
            SimpleCrumb,
            {
                name,
                icon,
                to: {
                    componentName: route.componentName
                },
                reportsPrefix
            }
        )

        registerBreadCrumbGetter(() => {
            const {currentPanelContent} = usePanelManager()
            if (currentPanelContent.value?.componentName !== route.componentName) {
                return
            }
            return crumb
        })

    }
    const registerBreadCrumbGetter = (evaluator: Function) => {
        breadcrumbContent.value.push(evaluator)
    }

    return {
        buildSimpleCrumb,
        registerBreadCrumbGetter,
        breadCrumbs
    }
}